export default __webpack_public_path__ + "static/media/horizontal-three-dots.ce309857.svg";